import { useQuery } from 'react-query';

import { useCurrentAssetId } from 'src/Hooks/Shared/useCurrentAssetId';
import { budgetApi } from 'src/Services/API';

/**
 * Prévisionnel v2 — lines of a year plus everything the API derives from them: section totals,
 * calculated cap, balance, financing need, per-household share and fund call suggestion.
 *
 * Every figure here is computed server side (`budget-math.util.ts`): the front never recomputes
 * a persisted amount, it only previews the wizard's unsaved state.
 */
const useBudgetYear = (year: number) => {
  const assetId = useCurrentAssetId();

  return useQuery({
    queryKey: ['budget', assetId, year, 'year'],
    queryFn: async () => {
      if (!assetId) throw new Error('No assetId provided');
      return (await budgetApi.budgetControllerGetYear(assetId, year)).data;
    },
    enabled: !!assetId,
  });
};

export default useBudgetYear;
